import gql from 'graphql-tag'
import {useQuery} from 'react-apollo'
import {Client} from '../../graphql/types'

const ACCOUNTS_WITH_PAMM_AGENT_OFFERS = gql`
  query Accounts {
    viewer {
      ... on Client {
        accounts(hidden: false, rejected: false) {
          ... on BaseAccount {
            pammAgentOffers {
              id
              name
              activeInvestmentCount
              currency
              managerId
              totalDepositSum
              manager {
                ... on BaseAccount {
                  id
                  client {
                    id
                    firstName
                    lastName
                  }
                }
              }
              managerName
              settings {
                agentChain {
                  agentId
                  client {
                    id
                  }
                }
                tradingInterval {
                  type
                  count
                }
                minDeposit
                minInitialInvestment
                minWithdrawal
                performanceFees {
                  levels {
                    level
                    value
                  }
                  mode
                }
              }
              skygroundAccountId
            }
          }
        }
      }
    }
  }
`

const isNotNil = <T>(value: T): value is NonNullable<T> => {
  if (typeof value === 'undefined') return false
  if (value === null) return false
  return true
}

export const usePammAgentOffers = () => {
  const {loading, data, error} = useQuery<{viewer: Client}>(ACCOUNTS_WITH_PAMM_AGENT_OFFERS)

  const pammAgentOffers =
    (data?.viewer?.accounts ?? [])
      .map((account) => account?.pammAgentOffers)
      .flat()
      .filter(isNotNil) ?? []

  return {error, loading, pammAgentOffers}
}
